import Collapse from "components/Collapse";
import EmptyState from "components/EmptyState";
import Loader from "components/Loader";
import { LinkIcon } from "lucide-react";
import XtmShareJobLink from "pages/project/common/taskBase/list/XtmShareJobLink";
import { useXtmData } from "query/task.query";
import { useTranslation } from "react-i18next";

interface Props {
  isTaskOngoing: boolean;
  taskId: string;
  /** Lets Task/Offer gate opening the XTM job behind the mandatory instructions confirmation. */
  onBeforeOpen?: (open: () => void) => void;
  /** Non-interactive links while mandatory-instruction ack cannot decide (loading/error). */
  disabled?: boolean;
}

export const XtmJobLinksTable = ({ taskId, isTaskOngoing, onBeforeOpen, disabled }: Props) => {
  const { t } = useTranslation();
  const { projects, isFetching, error } = useXtmData(taskId, isTaskOngoing, true);

  if (isFetching) {
    return <Loader isShown={true} />;
  }

  return (
    <Collapse
      defaultOpen={projects.length < 10}
      header={
        <h5 className="my-2 space-x-2 font-medium">
          <span>{t("task.detail.jobLinks.xtm.title")}</span>
          <span>({projects.length})</span>
        </h5>
      }
    >
      {projects.length === 0 ? (
        <EmptyState
          icon={LinkIcon}
          title={t("task.detail.delivery-files.title-no-files")}
          subtitle={error ? t("error:common.server") : t("task.detail.delivery-files.title-no-files-detail")}
        />
      ) : (
        <ul className="-my-4 ml-6 mt-2 list-none">
          {projects.map((project, index) => (
            <li key={`xtm link ${index}`} className="my-2">
              <XtmShareJobLink
                anonymousJobsLink={project.anonymousJobsLink}
                xtmProjectName={project.xtmProjectName}
                onBeforeOpen={onBeforeOpen}
                disabled={disabled}
              />
            </li>
          ))}
        </ul>
      )}
    </Collapse>
  );
};
